import { render } from "./Footer.vue?vue&type=template&id=6ad517cc&lang=pug"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"
script.render = render

export default script